<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ extraTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                {{ extraText }}
              </v-col>
              <v-col cols="12" class="bold">
                {{ $t('Kaina, Eur:') }} {{ kainaFormat }}
              </v-col>
              <v-col cols="12" class="text-bold" v-if="showBeKodo">
                <el-checkbox
                  :label="$t('Nerodyti asmens kodo')"
                  :tooltip="`${pazymaTooltipPrefix} Nerodyti asmens kodo`"
                  v-model="beKodo"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()" :loading="loading">
          {{ $t('Atšaukti') }}
        </el-button>
        <el-button primary :loading="loading" @click.native.stop="saveData()">
          Mokėti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import PazymaMap from './PazymaMap'

export default {
  name: 'ModalPazymaExtra',
  props: {
    value: Boolean,
    pazymaKodas: String,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      kaina: null,
      beKodo: false,
      yraFa: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazymaKodas)
    },
    pazymaTipas() {
      return this.pazymaMap.tipas
    },
    isTipasZemes() {
      return this.pazymaTipas === 'zemes-ukio'
    },
    isTipasSklypas() {
      return this.pazymaTipas === 'zemes-sklypas'
    },
    extraTitle() {
      return this.pazymaMap.extraTitle
    },
    extraText() {
      return this.pazymaMap.extraText
    },
    kainaFormat() {
      return this.moneyformat(this.kaina)
    },
    pazymaTooltipPrefix() {
      return this.pazymaMap.tooltipPrefix
    },
    showBeKodo() {
      return this.yraFa && !this.isTipasSklypas
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.pageloading = true
        this.getData()
      }
    },
  },
  methods: {
    getData() {
      this.loading = true

      const data = {
        pazyma_tipas: this.pazymaKodas,
      }

      this.$axios
        .post(`ntrpaslaugos/pazyma/extra`, data)
        .then(res => {
          this.kaina = res.data.pazyma_kaina
          this.yraFa = res.data.yra_fa
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loading = false
        })
    },
    saveData() {
      this.loading = true

      const data = {
        paz_tipas: this.pazymaKodas,
        be_kodo: this.beKodo,
      }

      this.$axios
        .post(`ntrpaslaugos/pazyma/extra/save`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$emit('confirmExtra', res.data)
          // this.closeModal()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
